import {
  StateCreator, UseBoundStore, StoreApi, create,
} from 'zustand';
import { immer } from 'zustand/middleware/immer';

export type ThemeType = 'light' | 'dark';

/** 供 Seedance SDK 等读写的 html data-theme 与主站同步。 */
export const ROBONEO_THEME_STORAGE_KEY = 'roboneo-theme';

interface IThemeState {
  theme: ThemeType;
}

const themeState: StateCreator<IThemeState, [
  ['zustand/immer', never],
]> = () => ({
  theme: 'dark',
});
const useThemeStore: UseBoundStore<StoreApi<IThemeState>> = create<IThemeState>()(immer(themeState));
export default useThemeStore;

/**
 * 设置主题：同步 body（主站 SCSS）、html data-theme / color-scheme（Seedance 工作台 token）与 localStorage，便于嵌入页与顶栏切换一致。
 * @export
 * @param {*} items
 */
export function setTheme(currentTheme: ThemeType) {
  if (typeof document !== 'undefined') {
    const { body, documentElement } = document;
    body.setAttribute('roboneo-data-theme', currentTheme);
    documentElement.dataset.theme = currentTheme;
    documentElement.style.colorScheme = currentTheme;
    try {
      window.localStorage.setItem(ROBONEO_THEME_STORAGE_KEY, currentTheme);
    } catch {
      /* noop */
    }
  }
  useThemeStore.setState(() => ({ theme: currentTheme }));
}

export function loggleTheme() {

}
